import { INPUT_TYPE_CHECKBOX } from 'common/entities/formNode/inputTypes';
import {
    ALL_OPERATOR_OPTIONS,
    EQUALS_OPERATOR_OPTIONS as CHECKBOX_OPERATOR_OPTIONS,
} from '../constants/operatorOptions';

export const isOperandCheckbox = (operandNode) => operandNode && operandNode.inputType === INPUT_TYPE_CHECKBOX;

export const getOperatorOptions = (operandNode) =>
    !isOperandCheckbox(operandNode) ? ALL_OPERATOR_OPTIONS : CHECKBOX_OPERATOR_OPTIONS;
